const vinExceptions = [
	{
		'1J8FAB4138L594480': {
			year: '2008',
			make: 'Jeep',
			model: 'Wrangler',
			engineSize: '3.8L',
		},
		'6G2EC57Y48L136865': {
			year: '2008',
			make: 'Pontiac',
			model: 'GTO',
			engineSize: '6.0L',
		},
		'1GCCSCFE3C8148189': {
			year: '2012',
			make: 'Chevrolet',
			model: 'Colorado',
			engineSize: '3.7L',
		},
	},
];

async function vinDecode(vinNum) {
	try {
		const isVinException = vinExceptions.find((exception) =>
			Object.keys(exception).includes(vinNum),
		);
		if (isVinException) {
			return { ...isVinException[vinNum], hasError: false, errorMsg: '' };
		}
		const trimmedVinNum = vinNum.replace(/[^a-zA-Z0-9]/g, '');
		const url = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVin/';
		const res = await fetch(url + trimmedVinNum + '?format=json');
		const data = await res.json();

		console.log('VIN Decode Response:', data);

		// Look up values by Variable name, not array index — NHTSA's
		// Results array reorders and changes length per VIN, so fixed
		// positions (e.g. Results[35]) silently break (engine -> "0.0L").
		const byName = (name) => {
			const row = data.Results.find((o) => o.Variable === name);
			return row ? row.Value : null;
		};

		const make = byName('Make');
		const model = byName('Model');
		const year = byName('Model Year');
		const displacement = byName('Displacement (L)');
		const engineSize = displacement
			? Number(displacement).toFixed(1).toString() + 'L'
			: '';
		const hasError = byName('Error Code') === '0' ? false : true;
		const errorMsg = byName('Error Text');

		console.log('VIN Decode Results:', {
			year,
			make,
			model,
			engineSize,
			hasError,
			errorMsg,
		});

		return { year, make, model, engineSize, hasError, errorMsg };
	} catch (err) {
		console.error(err);
	}
}

function createSessionValues(year, make, model, engineSize) {
	sessionStorage.setItem('yearFromVin', year);
	sessionStorage.setItem('makeFromVin', make);
	sessionStorage.setItem('modelFromVin', model);
	sessionStorage.setItem('engineSizeFromVin', engineSize);
}

function removeSessionValues() {
	sessionStorage.removeItem('yearFromVin');
	sessionStorage.removeItem('makeFromVin');
	sessionStorage.removeItem('modelFromVin');
	sessionStorage.removeItem('engineSizeFromVin');
}

function getOneSessionValue(key) {
	return sessionStorage.getItem(key);
}

function getAllSessionValues() {
	return {
		year: sessionStorage.getItem('yearFromVin'),
		make: sessionStorage.getItem('makeFromVin'),
		model: sessionStorage.getItem('modelFromVin'),
		engineSize: sessionStorage.getItem('engineSizeFromVin'),
	};
}
